module.exports = __webpack_public_path__ + "static/media/asset_TV_UI.9f91203b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Features/Watch/img/asset_TV_UI.png
// module id = 173
// module chunks = 0